import { render, staticRenderFns } from "./EveryDayMenu.vue?vue&type=template&id=ccaeddd8&scoped=true&"
import script from "./EveryDayMenu.vue?vue&type=script&lang=js&"
export * from "./EveryDayMenu.vue?vue&type=script&lang=js&"
import style0 from "./EveryDayMenu.vue?vue&type=style&index=0&id=ccaeddd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccaeddd8",
  null
  
)

export default component.exports